import { computeHalfTrimWidth } from '../../helpers/page-trim-width'

/**
 * Bindery gutter X — centers `centerGap` on the spine so yellow + spine line split evenly.
 * `spineSnapCanvasX`, when given, is the device-pixel-snapped seam shared with the ruler "0" tick,
 * spine bar, and page-trim split (`double-spread-document.tsx`) — passing it keeps the gutter tint
 * centered on the same seam those draw at, instead of an independently-floored approximation that
 * can drift a fraction of a point off it.
 */
export function gutterLeftPx(
  bleedMargin: number,
  trimWidth: number,
  centerGap: number,
  spineSnapCanvasX?: number
): number {
  const pageTrimWidth = computeHalfTrimWidth(trimWidth)
  const spineX = spineSnapCanvasX ?? bleedMargin + pageTrimWidth

  return spineX - centerGap / 2
}
